module.exports = __webpack_public_path__ + "static/media/logo2.08692c0e.png";